// Der Seitenstapel der App-Ansicht — reine Rechnerei, kein React, kein DOM.
//
// Ein linearer Stapel, der den Browserverlauf spiegelt. Bewusst NICHT ein
// eigener Stapel je Tableistenpunkt: das ist zwar das Verhalten von iOS,
// kämpft aber gegen den einen linearen Verlauf des Browsers und gegen die
// Zurück-Taste von Android. Ein Stapel, eine Wahrheit.
//
// Alle Ebenen bleiben später eingehängt. Dadurch überleben Scrollposition
// und halb getippte Eingaben den Ausflug in die Tiefe — genau das ist der
// Unterschied zwischen einer App und einer Website.

export type Ort = {
  pfad: string;
  /** `location.key` von react-router: eindeutig je Verlaufseintrag. */
  schluessel: string;
};

export type Art = 'PUSH' | 'POP' | 'REPLACE';

/**
 * Mehr Ebenen hält niemand im Kopf, und jede kostet Speicher, weil sie
 * eingehängt bleibt. Die unterste fällt heraus — zurück führt dann eine
 * Ebene weniger weit, was niemandem auffällt.
 */
export const MAX_EBENEN = 8;

export function naechsterStapel(stapel: Ort[], ort: Ort, art: Art): Ort[] {
  // Dieselbe Stelle noch einmal: nichts tun. React ruft Effekte mehrfach auf,
  // und ein doppelter PUSH würde die Seite zweimal in den Stapel legen.
  const oben = stapel[stapel.length - 1];
  if (oben && oben.schluessel === ort.schluessel) return stapel;

  if (art === 'POP') {
    // Bis zu dem Eintrag abschneiden, zu dem zurückgesprungen wurde.
    const stelle = stapel.findIndex(e => e.schluessel === ort.schluessel);
    // Unbekannt heißt: der Verlauf führt an diesem Stapel vorbei, etwa nach
    // einem Rücksprung aus einer anderen Sitzung. Dann beginnt er neu.
    return stelle === -1 ? [ort] : stapel.slice(0, stelle + 1);
  }

  if (art === 'REPLACE') {
    return stapel.length === 0 ? [ort] : [...stapel.slice(0, -1), ort];
  }

  const neu = [...stapel, ort];
  return neu.length > MAX_EBENEN ? neu.slice(neu.length - MAX_EBENEN) : neu;
}

/** Tableistenwechsel: der gewählte Punkt wird zur alleinigen Wurzel. */
export function aufWurzel(_stapel: Ort[], wurzel: Ort): Ort[] {
  return [wurzel];
}

/**
 * Beim Wechsel auf die Schreibtisch-Breite gibt es keinen Stapel mehr.
 * Die oberste Ebene ist, was der Benutzer gerade sieht — sie bleibt.
 */
export function eingedampft(stapel: Ort[]): Ort[] {
  return stapel.length <= 1 ? stapel : [stapel[stapel.length - 1]];
}
